<header mat-dialog-title class="u-flex-full">
  <span>
    {{'currencies.Seleziona valuta' | translate}}
  </span>
</header>
<mat-dialog-content>
  <currency-list [currencies]="currencies" [defaultFilters]="defaultFilters" [displayedColumns]="displayedColumns" [total]="total"
    [canSelect]="true" (onSortChange)="sortChange($event)" (onPageChange)="pageChange($event)"
    (onFilterChange)="filtersChange($event)" (onSelectCurrency)="selectCurrency($event)"></currency-list>
</mat-dialog-content>
<mat-dialog-actions class="u-flex-full">
  <span>
  </span>
  <button mat-raised-button color="basic" type="button" (click)="close()">{{'shared.Chiudi' | translate}}</button>
</mat-dialog-actions>
